import { ChaseAmountDetail } from "../../invoice/invoices/model/chase-amount-detail.model";

export class ChaseInvoiceStatusChangeRequest {
    chaseAmountDetails?: ChaseAmountDetail[];
    status: string;

    constructor(options: Partial<ChaseInvoiceStatusChangeRequest>) {
        this.chaseAmountDetails = options.chaseAmountDetails;
        this.status = options.status;
    }
}
